import type { WorkspaceSummary } from '../types/workspace.js';

export function filterWorkspaces(
  workspaces: WorkspaceSummary[],
  query: string,
  includeDescription = false,
): WorkspaceSummary[] {
  const normalizedQuery = query.trim().toLowerCase();
  return workspaces.filter((workspace) =>
    [
      workspace.name,
      workspace.displayName,
      ...(includeDescription ? [workspace.description] : []),
    ].some((value) => value?.toLowerCase().includes(normalizedQuery)),
  );
}
